import React, { useEffect, useState } from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
export const SHOPIFY_LINK = 'https://shop.dermaclinicenter.com/cart/50280035188956:1';
export const WHATSAPP_URL = 'https://wa.me/13322817703?text=Hola%2C%20vengo%20de%20A.R.M.O.N.Y.%20Quiero%20informaci%C3%B3n%20antes%20de%20comprar%20el%20material.';
const PASSTHROUGH_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid'] as const;
function buildCartLink(): string {
  if (typeof window === 'undefined') return SHOPIFY_LINK;
  try {
    let attribution: Record<string, string | null | undefined> = {};
    // Prefer sessionStorage (set by GTM bootstrap) so attribution
    // survives cross-route navigation and matches the GTM dataLayer.
    const stored = sessionStorage.getItem('armony_attribution');
    if (stored) {
      attribution = JSON.parse(stored) || {};
    } else {
      // First-touch fallback before GTM has run: read directly from URL.
      const search = new URLSearchParams(window.location.search);
      PASSTHROUGH_PARAMS.forEach(key => {
        const value = search.get(key);
        if (value) attribution[key] = value;
      });
    }
    // Filter out GTM's 'direct' / 'none' defaults and empty values —
    // we only forward real attribution to the cart URL.
    const filtered: Record<string, string> = {};
    Object.keys(attribution).forEach(k => {
      const v = attribution[k];
      if (v && v !== 'direct' && v !== 'none') {
        filtered[k] = String(v);
      }
    });
    const qs = new URLSearchParams(filtered).toString();
    return qs ? `${SHOPIFY_LINK}?${qs}` : SHOPIFY_LINK;
  } catch {
    return SHOPIFY_LINK;
  }
}
export function useCartLink(): string {
  const [href, setHref] = useState<string>(SHOPIFY_LINK);
  useEffect(() => {
    setHref(buildCartLink());
  }, []);
  return href;
}
type CTAProps = {
  className?: string;
  label?: string;
  oldPrice?: string | null;
  price?: string;
  ctaId?: 'hero' | 'final' | 'sticky' | 'legal';
};
export function PrimaryCTA({
  className = '',
  label = 'Quiero el bundle completo',
  oldPrice = '$47',
  price = '$17',
  ctaId = 'hero'
}: CTAProps) {
  const href = useCartLink();
  return <a href={href} target="_blank" rel="noopener noreferrer" data-cta={ctaId} className={`cta-btn ${className}`} data-id="element-115">
      <span className="cta-btn__icon" aria-hidden="true" data-id="element-116">
        ✦
      </span>
      <span className="cta-btn__label" data-id="element-117">{label}</span>
      <span className="cta-btn__sep" aria-hidden="true" data-id="element-118">
        ·
      </span>
      {oldPrice ? <span className="cta-btn__oldprice" aria-hidden="true" data-id="element-119">
          {oldPrice}
        </span> : null}
      <span className="cta-btn__price" data-id="element-120">{price}</span>
    </a>;
}
type WhatsAppLinkProps = {
  ctaId: 'hero_whatsapp' | 'final_whatsapp' | 'footer_whatsapp';
};
export function WhatsAppLink({
  ctaId
}: WhatsAppLinkProps) {
  return <p className="wa-link" data-id="element-121">
      ¿Prefieres conversar antes?{' '}
      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-cta={ctaId} className="wa-link__a" data-id="element-122">
        Escríbenos por WhatsApp
      </a>
      .
    </p>;
}
export function TrustSignals() {
  return <div className="trust-signals" data-id="element-123">
      <span className="trust-item" data-id="element-124">
        <LockIcon className="trust-icon" size={13} strokeWidth={1.75} aria-hidden="true" data-id="element-125" />
        Pago seguro
      </span>
      <span className="trust-item" data-id="element-126">
        <CheckIcon className="trust-icon" size={13} strokeWidth={1.75} aria-hidden="true" data-id="element-127" />
        Acceso inmediato
      </span>
      <span className="trust-item" data-id="element-128">
        <ShieldCheckIcon className="trust-icon" size={13} strokeWidth={1.75} aria-hidden="true" data-id="element-129" />
        Garantía 14 días
      </span>
    </div>;
}
export function Eyebrow({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="eyebrow" data-id="element-130">{children}</span>;
}